export const app = {
  BACKEND_URL: 'https://api.ireserve.smartssi.net',
  //BACKEND_URL: 'https://preprod-vinereserveclub.smartssi.net',
  //BACKEND_URL: 'https://api.ireserve.io',
}